import React, { useEffect } from "react";
import { Car } from "phosphor-react";
import Select from "../Inputs/Select";
import Loading from "../Loading/Loading";
import useType, { TYPES } from "../../utils/hooks/useType";
import styled from "styled-components";

export function BrandSelect({
  brands,
  setBrand,
  setRange,
  setModel,
  fetchRanges,
  brand,
  isFetchingBrands,
  validate,
}) {
  const [keywords, setKeywords] = useType(TYPES.STRING, "");
  const [brandsFiltered, setBrandsFiltered] = useType(TYPES.ARRAY, brands);

  useEffect(() => {
    if (keywords?.length > 0) {
      const results = brands?.filter(b => b.brand.toLowerCase().startsWith(keywords.toLowerCase()));
      console.log('results', results);
      setBrandsFiltered(results);
    } else setBrandsFiltered(brands || []);
  }, [keywords, brands, setBrandsFiltered]);

  return (
    <Select
      options={brandsFiltered?.sort((a, b) => {
        if (a.brand.toLowerCase() > b.brand.toLowerCase()) {
          return 1;
        }
        if (a.brand.toLowerCase() < b.brand.toLowerCase()) {
          return -1;
        }
        return 0;
      })?.map((b) => b.brand)}
      defaultValue={
        !brands || brands?.length === 0
          ? "No brands"
          : <StyledSearchInput value={keywords} onChange={e => setKeywords(e.target.value)} autoFocus={true} placeholder="Filter" />
      }
      handleChange={(value) => {
        setRange("");
        setModel("");
        setBrand(value);
        fetchRanges(true);
      }}
      value={brand}
      prefix={
        isFetchingBrands ? (
          <Loading />
        ) : (
          <Car size={14} weight="regular" color="var(--carter-secondary)" />
        )
      }
      label="Brand*"
      id="brand"
      validate={validate}
    />
  );
}

const StyledSearchInput = styled.input`
  width: 120px;
  border: 1px solid lightgray;
  outline: none;
  padding: 2px 5px;
`;